const Report = () =>
  import(
    /* webpackChunkName: "financial-tariff-freight" */ '@/pages/financial/tariff/freight/freight-tariff/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "financial-tariff-freight" */ '@/pages/financial/tariff/freight/freight-tariff/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "financial-tariff-freight" */ '@/pages/financial/tariff/freight/freight-tariff/edit.vue'
  )

export default {
  name: 'FreightTariff',
  path: 'freight-tariff',
  meta: {
    label: 'freight',
    auth: 'freight'
  },
  component: {
    name: 'Freight',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialTariffFreightReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'FinancialCreateFreightTariff',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'FinancialEditFreightTariff',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
